import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { textSize, Points, paddingLevel } from '@styles';
import { useTranslations } from '@libs/translations';

export const Navigation = ({ navigations = [], currentCategory = 'all' }) => {
  const translations = useTranslations();

  return (
    <Container>
      <ul>
        <CategoryLink isActive={currentCategory === 'all'} isMobile={deviceDetected.isMobile}>
          <Link href="/blog/">
            <a>{translations.t('site.blog.all')}</a>
          </Link>
        </CategoryLink>
        {navigations.map(({ category, name }) => (
          <CategoryLink key={category} isActive={currentCategory === category} isMobile={deviceDetected.isMobile}>
            <Link href={`/blog/${category}/`}>
              <a>{name}</a>
            </Link>
          </CategoryLink>
        ))}
      </ul>
    </Container>
  );
};

const Container = styled.nav`
  ${paddingLevel('bottom', 'dark_cream')};
  overflow: auto;
  white-space: nowrap;

  ul {
    ${Mixins.resetList()};
    text-align: center;
  }
`;

const CategoryLink = styled.li`
  ${Mixins.transition('color')};
  ${textSize('footerLink')};
  margin: 0 5px;
  display: inline-block;
  color: ${({ isActive }) => (isActive ? Colors.coal : Colors.nobel)};

  @media ${Points.laptop} {
    margin: 0 10px;
  }

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    color: ${(p) => !p.isMobile && Colors.coal};
  }

  a {
    ${Mixins.resetLink()};
  }
`;
